import { render } from "./characterList.vue?vue&type=template&id=2f7b9da5&bindings={\"characterList\":\"data\"}"
import script from "./characterList.vue?vue&type=script&lang=js"
export * from "./characterList.vue?vue&type=script&lang=js"
script.render = render

export default script